import React from 'react'

export interface SignatureDimensionsContext {
  width: number
  height: number
}

const SignatureDimensionsContext = React.createContext<
  SignatureDimensionsContext | undefined
>(undefined)

export const useSignatureDimensions = () =>
  React.useContext(SignatureDimensionsContext)!

export const SignatureDimensionsProvider = ({
  children,
  ...value
}: {
  children: React.ReactNode
} & SignatureDimensionsContext) => {
  return (
    <SignatureDimensionsContext.Provider value={value}>
      {children}
    </SignatureDimensionsContext.Provider>
  )
}
